import React, { Component, Suspense } from 'react';
import { useDispatch } from 'react-redux'
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { modalActionCreator } from '../../store/actions';
import { Card, Form, Col, Button } from 'react-bootstrap'
import FormControls from '../../controls/formControls';
import UserService from '../../services/UserService';
import { BusyButton } from '../../controls/Buttons';

//const validPassword = RegExp(/^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/i);
//const validPassword = RegExp(/^\(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[@$!%*?&])([a-zA-Z0-9@$!%*?&]{8,})$/i)

const resetPasswordValsInitValues = {
    currentPassword: '',
    newPassword: '',
    newPasswordConfirm: ''
}

const resetPasswordValsValidation = Yup.object().shape({
    currentPassword: Yup.string().required('You must enter your current password.'),
    newPassword: Yup.string()
        .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[@$!%*?&]).{8,}$/, 'Your new password must contain at least one upper case letter, one lower case leter, one number, one special character (@$!%*?&), and a minimum of eight characters.')
        .notOneOf([Yup.ref('currentPassword'), null], 'New password cannot be the same as current password.')
        .required('No password entered.'),
    newPasswordConfirm: Yup.string()
        .oneOf([Yup.ref('newPassword'), null], 'Passwords must match.')
});

const UserChangePassword = (props) => {

    const dispatch = useDispatch();

    const showModal = (props, type) => {
        dispatch(modalActionCreator.showModal(props, type));
    }

    const closeModal = () => {
        dispatch(modalActionCreator.hideModal());
    }

    const showAlertModal = (title, message) => {
        showModal({
            open: true,
            title: title,
            message: message,
            closeModal: closeModal,
        }, 'alertModal')
    }

    const formik = useFormik({
        initialValues: resetPasswordValsInitValues,
        validationSchema: resetPasswordValsValidation,
        enableReinitialize: true,
        onSubmit: async (values, { setSubmitting, setErrors, setStatus, resetForm }) => {
            var userService = new UserService();
            var returnVal = await userService.changePassword(values)
            if (!returnVal.result) {
                showAlertModal("Error!", returnVal.message);
            } else {
                showAlertModal("Success!", returnVal.message);
            }
            setSubmitting(false);
            resetForm();
        }
    });

    return (
        <Card>
            <Card.Header className="d-flex align-items-center">
                <div className="mr-auto" >Change Password</div>
                <div className="card-btn-group">
                </div>
            </Card.Header>
            <Card.Body>
                <Form.Row>
                    <Form.Group as={Col} md={4}>
                        <FormControls.Textbox
                            type="password"
                            label="Current Password"
                            name="currentPassword"
                            formHandler={formik}
                            placeholder="Enter old password"
                        />
                    </Form.Group>
                </Form.Row>
                <Form.Row>
                    <Form.Group as={Col} md={4}>
                        <FormControls.Textbox
                            type="password"
                            name="newPassword"
                            label="New Password"
                            formHandler={formik}
                            placeholder="Enter new password"
                            type="password"
                        />

                    </Form.Group>
                    <Form.Group as={Col} md={4}>
                        <FormControls.Textbox
                            type="password"
                            name="newPasswordConfirm"
                            label="Confirm New Password"
                            formHandler={formik}
                            placeholder="Enter new password again"
                            type="password"
                        />
                    </Form.Group>
                </Form.Row>
                <BusyButton variant="primary" onClick={formik.submitForm}>Reset Password</BusyButton>
            </Card.Body>
        </Card>
    );
}
export default UserChangePassword;

class UserChangePassword2 extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = { queues: [{ codingEvents: [] }] };
    }

    render() {
        return (
            <Card>
                <Card.Header className="d-flex align-items-center">
                    <div className="mr-auto" >Change Password</div>
                    <div className="card-btn-group">
                    </div>
                </Card.Header>
                <Card.Body>
                    <Form.Row>
                        <Form.Group as={Col} md={4}>
                            <Form.Label>Old password</Form.Label>
                            <Form.Control
                                type="password"
                                id="oldPassword"
                                name="oldPassword"
                                placeholder="Enter old password"
                                value={this.state.changePassValues.oldPassword}
                                onChange={this.handleUserInput}
                                onBlur={this.validateAll} />
                            <Form.Label>New password</Form.Label>
                            <Form.Control
                                id="newPassword"
                                name="newPassword"
                                placeholder="Enter new password"
                                type="password"
                                pattern="^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[@$!%*?&])([a-zA-Z0-9@$!%*?&]{8,})"
                                value={this.state.changePassValues.newPassword}
                                onChange={this.handleUserInput}
                                onBlur={this.validateAll} />
                            <Form.Label>Confirm new password</Form.Label>
                            <Form.Control
                                id="newPasswordConfirm"
                                name="newPasswordConfirm"
                                pattern="^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[@$!%*?&])([a-zA-Z0-9@$!%*?&]{8,})"
                                placeholder="Enter new password again"
                                type="password"
                                value={this.state.changePassValues.newPasswordConfirm}
                                onChange={this.handleUserInput}
                                onBlur={this.validateAll} />
                        </Form.Group>
                    </Form.Row>
                </Card.Body>
            </Card>
        );
    }

}

//export UserChangePassword2;